import { FC } from 'react';
import { SHARED_STYLES } from './constants';

export const LoadingState: FC<{ message: string }> = ({ message }) => <div css={SHARED_STYLES.loading}>{message}</div>;

// Inline empty circle component to avoid build issues
export const EmptyCircleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#F8F8F8" />
    <circle cx="8" cy="8" r="6" stroke="#CBCAC9" strokeWidth="1" fill="none" />
  </svg>
);
